import { customGetAPIWithToken } from "./CustomAPI";
import { canUseCompanyContext } from "./companyAccess";
import { defaultAllSelection } from "services/constants/selections";

const isAllCompanies = (company) =>
  String(company?.company_id) === String(defaultAllSelection);

export const selectLoginCompany = (companies, userType, preferredId) => {
  const usable = companies.filter((company) =>
    canUseCompanyContext(company?.company_id, userType, companies),
  );
  // The topbar no longer offers "All Companies", so login lands on a real
  // company (backend order). All is used only when it is the user's sole
  // entry.
  const realCompanies = usable.filter((company) => !isAllCompanies(company));
  const candidates = realCompanies.length ? realCompanies : usable;
  const preferred = candidates.find(
    (company) => String(company?.company_id) === String(preferredId),
  );
  return preferred || candidates[0] || null;
};

// Resolve company membership before requesting products. An unscoped request
// can return no products even when the user has grants in an assigned company.
export const loadLoginAccess = async ({ domain, token, userType, preferredId }) => {
  const companyResponse = await customGetAPIWithToken(
    `${domain}user-group/user/company/`, token,
  );
  if (!companyResponse?.ok || !Array.isArray(companyResponse.responseDetails)) {
    throw new Error("Couldn't load your company access. Please try again.");
  }
  const companies = companyResponse.responseDetails;
  const company = selectLoginCompany(companies, userType, preferredId);
  if (!company) return { companies, company: null, products: [] };
  const productResponse = await customGetAPIWithToken(
    `${domain}login/available/products/?company_id=${encodeURIComponent(company.company_id)}`, token,
  );
  if (!productResponse?.ok || !Array.isArray(productResponse.responseDetails)) {
    throw new Error("Couldn't load your module access. Please try again.");
  }
  return { companies, company, products: productResponse.responseDetails };
};

export const storeLoginAccess = ({ companies, company, products }) => {
  localStorage.setItem("companyAccess", JSON.stringify(companies));
  localStorage.setItem("productAccess", JSON.stringify(products));
  if (company) {
    localStorage.setItem("topbarCompanyId", company.company_id);
    localStorage.setItem("topbarCompanyName", company.company_name);
  } else {
    localStorage.removeItem("topbarCompanyId");
    localStorage.removeItem("topbarCompanyName");
  }
};
